var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataPortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24.000000pt",
    height: "24.000000pt",
    viewBox: "0 0 24.000000 24.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,24.000000) scale(0.002053,-0.003141)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8720 7285 c-242 -54 -428 -202 -531 -420 -55 -119 -73 -212 -66 -359 5 -129 23 -199 77 -306 68 -135 198 -263 334 -330 l64 -32 -20 -56 c-10 -32 -161 -475 -335 -987 -173 -511 -324 -956 -335 -987 l-19 -57 -107 6 c-146 8 -245 -12 -380 -78 -86 -42 -117 -64 -189 -134 l-87 -84 -1260 856 c-694 470 -1267 861 -1274 867 -11 10 -8 26 12 87 93 278 23 576 -183 779 -161 157 -343 227 -566 217 -284 -13 -513 -164 -641 -422 -54 -109 -74 -197 -74 -331 0 -210 71 -380 224 -534 l66 -66 -596 -1205 c-327 -662 -599 -1207 -602 -1211 -4 -4 -30 0 -57 9 -36 12 -89 17 -190 17 -158 1 -232 -16 -356 -81 -360 -188 -504 -641 -319 -1008 94 -186 284 -339 484 -390 288 -72 608 37 782 268 161 215 202 475 113 721 -49 137 -135 252 -265 356 l-32 25 593 1195 c327 657 595 1199 597 1204 2 5 33 -1 68 -13 267 -90 576 -17 777 185 l54 54 1277 -867 c702 -476 1278 -867 1280 -868 1 -1 -6 -26 -17 -56 -125 -363 52 -770 403 -929 108 -49 180 -64 311 -64 146 0 214 16 345 81 79 39 110 62 185 138 141 141 212 296 222 490 15 277 -119 534 -355 682 -40 25 -71 51 -69 57 2 6 160 470 350 1031 190 561 348 1027 352 1036 5 13 28 17 123 22 136 7 207 24 317 77 193 93 340 273 396 488 28 105 28 268 1 373 -70 264 -277 473 -537 544 -85 23 -264 28 -345 10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPortal);
export default __webpack_public_path__ + "static/media/DataPortal.e13d48ccba07b09a49f951fa8a2cd916.svg";
export { ForwardRef as ReactComponent };